module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-landing-funds-0a7bfe71bb9ada7afe5c38985a055461.svg";